export default __webpack_public_path__ + "static/media/orangeTicket@3x.995644a3.png";